// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "[data-v-6e95b97d] .el-scrollbar__view {\n  height: 100%;\n}\n", ""]);
// Exports
module.exports = exports;
